// src/components/Layout.tsx
import React from 'react';
import Header from './Header';
import ContentArea from './ContentArea';
import Sidebar from './Sidebar';
import styled from 'styled-components';

const LayoutWrapper = styled.div`
  font-family: 'Arial', sans-serif;
  background-color: #f9f9f9;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevents page-level scrolling */
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto; /* ✅ Allow scrolling within this container */
  height: calc(100vh - 64px); /* Adjust height by subtracting the header height */

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;



const ResponsiveContentArea = styled(ContentArea)`
  flex: 1;
  overflow-y: auto; /* Enable scrolling if content overflows */
`;

const ResponsiveSidebar = styled(Sidebar)`
  @media (max-width: 768px) {
    display: none;
  }
`;

const Layout: React.FC = () => {
  return (
    <LayoutWrapper>
      <Header />
      <ContentWrapper>
        <ResponsiveContentArea />
        <ResponsiveSidebar />
      </ContentWrapper>
    </LayoutWrapper>
  );
};

export default Layout;
